import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import { ThunkDispatch } from 'redux-thunk';

import { loadJobDetails } from '../../action/job/load-job-details';
import { loadJobRoles } from '../../action/load-job-roles';
import { jobRoleSelector } from '../../reducers/job-role-selectors';
import { jobDetailsSelector } from '../../reducers/job-selectors';

import { JobFieldLicense } from '../../job/fields/job-field-license';

import { JobFlowButtons } from './job-flow-buttons';

const FORM_NAME = 'jobFlowLicenses';

const mapStateToProps = (state: any, ownProps: InputProps) => {
  const jobDetails = ownProps.jobId ? jobDetailsSelector(state, ownProps.jobId) : undefined;
  const selector = formValueSelector(FORM_NAME);

  return {
    jobDetails,
    relevantLicenses: selector(state, 'relevantLicenses') || [],
    initialValues: { relevantLicenses: jobDetails?.relevantLicenses },
    jobRole: ownProps.jobRoleId ? jobRoleSelector(state, ownProps.jobRoleId) : undefined,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadJobDetails: () => (ownProps.jobId ? dispatch(loadJobDetails(ownProps.jobId)) : undefined),
    loadJobRoles: () => dispatch(loadJobRoles()),
  },
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type JobFlowLicensesComponentProps = InputProps & StateProps & DispatchProps;
type JobFlowLicensesFields = Partial<Job>;
type Props = InjectedFormProps<JobFlowLicensesFields, JobFlowLicensesComponentProps> &
  JobFlowLicensesComponentProps;

interface InputProps extends JobFlowStep {
  jobId?: number;
  jobRoleId?: number | null;
}

class JobFlowLicensesComponent extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.actions.loadJobDetails();
    this.props.actions.loadJobRoles();
  }

  componentDidUpdate(prevProps: Props) {
    this.props.actions.loadJobDetails();
    this.props.actions.loadJobRoles();
    if (prevProps.dirty !== this.props.dirty) {
      this.props.onDirty(this.props.dirty);
    }
  }

  render() {
    const {
      onNext,
      onPrev,
      onSkip,
      jobId,
      jobDetails,
      handleSubmit,
      relevantLicenses,
      saving,
      jobRole,
      editing,
    } = this.props;

    if (!jobDetails || !jobDetails.relevantLicenses || !jobId) {
      return null;
    }

    return (
      <form onSubmit={handleSubmit(onNext)}>
        <JobFieldLicense
          jobId={jobId}
          jobDetails={jobDetails}
          suggestions={jobRole && jobRole.suggestedLicenses}
        />
        <JobFlowButtons
          disabled={!relevantLicenses.length}
          onPrev={onPrev}
          onSkip={onSkip}
          editing={editing}
          saving={saving}
        />
      </form>
    );
  }
}

export const JobFlowLicenses = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm<JobFlowLicensesFields, JobFlowLicensesComponentProps>({
    form: FORM_NAME,
    enableReinitialize: true,
  })(JobFlowLicensesComponent),
);
